import styled, { css, DefaultTheme, keyframes } from 'styled-components/macro';
import { StyledChipProps } from './chip.types';
import { focus } from '../button/styled-mixins';

const sizeMap = (theme: DefaultTheme) =>
  ({
    m: {
      padding: `${theme.spacings.xxs} ${theme.spacings.xs}`,
      borderRadius: theme.radiuses.xxs,
    },
    s: {
      padding: `2px ${theme.spacings.xs}`,
      borderRadius: theme.radiuses.xxxs,
    },
  }) as const;

const closeKeyframes = keyframes`
  0% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
`;

export const StyledChip = styled.div<StyledChipProps>`
  ${({ theme, $size, $isClosing }) => {
    const { padding, borderRadius } = sizeMap(theme)[$size];

    return css`
      display: inline-flex;
      align-items: center;
      gap: ${theme.spacings.xs};
      padding: ${padding};
      width: fit-content;
      max-width: 100%;
      background-color: ${theme.semantic.chip.bg};
      color: ${theme.semantic.text.default};
      border-radius: ${borderRadius};
      white-space: nowrap;

      cursor: default;

      &:not([aria-disabled='true']):hover {
        background-color: ${theme.semantic.chip.bgHover};
      }

      ${focus(theme.semantic.focus.ringAccent)}

      &[aria-disabled='true'] {
        opacity: 0.5;
        cursor: not-allowed;
      }

      ${$isClosing &&
      css`
        animation: ${closeKeyframes} ${theme.tokens.animation.duration.base}
          ${theme.tokens.animation.easing.easeInOut} forwards;
        pointer-events: none;
      `}
    `;
  }}
`;

export const IconWrapper = styled.span`
  display: inline-flex;
  align-items: center;
`;
